/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteFacilityPhysician200ResponseData } from './DeleteFacilityPhysician200ResponseData';
import {
    DeleteFacilityPhysician200ResponseDataFromJSON,
    DeleteFacilityPhysician200ResponseDataFromJSONTyped,
    DeleteFacilityPhysician200ResponseDataToJSON,
} from './DeleteFacilityPhysician200ResponseData';

/**
 * 
 * @export
 * @interface DeleteFacilityPhysician200Response
 */
export interface DeleteFacilityPhysician200Response {
    /**
     * 
     * @type {DeleteFacilityPhysician200ResponseData}
     * @memberof DeleteFacilityPhysician200Response
     */
    data?: DeleteFacilityPhysician200ResponseData;
}

/**
 * Check if a given object implements the DeleteFacilityPhysician200Response interface.
 */
export function instanceOfDeleteFacilityPhysician200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteFacilityPhysician200ResponseFromJSON(json: any): DeleteFacilityPhysician200Response {
    return DeleteFacilityPhysician200ResponseFromJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityPhysician200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DeleteFacilityPhysician200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteFacilityPhysician200ResponseToJSON(value?: DeleteFacilityPhysician200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteFacilityPhysician200ResponseDataToJSON(value.data),
    };
}

